<template>
  <div class="slider-monthyPlan pb-6 md:pb-8 border-b w-full">
    <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack">本月企劃</h3>
    <swiper :options="montlyOption" class="swiper w-full">
      <swiper-slide v-for="(item, index) in planData" :key="index" class="item cursor-pointer flex flex-col">
        <a class="cursor-pointer w-full" :href="item.url" target="_blank">
          <div class="slider-img sm:px-2 flex justify-center w-full mb-2 md:mb-3 lg:mb-4 cursor-pointer">
            <img :src="item.image_url" class="w-full h-full" :alt="item.name">
          </div>
        </a>
        <div class="lg:pl-2 monthyPlan-text text-center lg:text-left w-full">
          <p class="p-0 mb-0 monthyPlan-activty text-base textColorBlack truncate">
            {{ item.name }}
          </p>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  props: {
    planData: {
      type: Array
    }
  },
  data () {
    return {
      montlyOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          576: {
            slidesPerView: 1
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    transition: .3s;
  }
  .monthyPlan-text {
    .monthyPlan-activty {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
</style>
